<div class="text-end mb-3">
  <div class="text-xxs d-inline-block text-start w-25">
    <label>Filter by Role:</label>
    <select
      v-model="selected_role"
      class="modal-form-select form-select text-xxs rounded-3 p-2 shadow-sm"
      @change="on_role_change"
      >
      <option v-for="role in roles" :key="role.id" :value="role.id">
        {{ role.name }}
      </option>
    </select>
  </div>
</div>
<GlobalTable
  v-if="available_widgets.length > 0"
  :headers="widget_headers"
  :data="available_widgets"
  :key="available_widgets"
  table_id="widget_assignment_table">
  <template #actions="{ row }">
    <div class="form-check form-switch">
      <input
        class="form-check-input"
        type="checkbox"
        :id="'switch_' + row.id"
        :checked="assigned_widgets.includes(row.id)"
        @change="toggle_assignment(row.id, !assigned_widgets.includes(row.id))">
      <label class="form-check-label" :for="'switch_' + row.id">
        {{ assigned_widgets.includes(row.id) ? 'Assigned' : 'Unassigned' }}
      </label>
    </div>
  </template>
</GlobalTable>